import React from 'react'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react';
import Header from '../components/layout/header'

function About() {
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      window.scrollTo(0, 0);
    }
    else {
      const middleOfPage = document.documentElement.scrollHeight / 4;
      window.scrollTo({
        top: middleOfPage,
        behavior: 'smooth'
      });
    }
  }, []);
    return (
      <>
        <Header/>
        <Outlet />
      </>
  )
}

export default About